import { SvgIcon, SvgIconProps } from "@mui/material";

export const AddUserIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="16.752" cy="17.75" r="4.25" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M18.002 17.75h-2.5M16.752 16.5V19"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M10 15H7a4 4 0 0 0-4 4v1"/><circle cx="10.998" cy="7" r="4" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/></svg>
  </SvgIcon>
);
